export enum Role {
  Admin = 'Admin',
  Host = 'Host',
  Coordinator = 'Coordinator',
  Teacher = 'Teacher',
  Student = 'Student',

  Participant = 'Participant'
}

export function localizeRole(role: Role): string {
  let value: string = '';

  switch (role) {
    case Role.Admin:
      value = $localize`:General|Role Admin title@@general-role-admin-title:Admin`;
      break;
    case Role.Host:
      value = $localize`:General|Role Host title@@general-role-host-title:Host`;
      break;
    case Role.Coordinator:
      value = $localize`:General|Role Coordinator title@@general-role-coordinator-title:Coordinator`;
      break;
    case Role.Teacher:
      value = $localize`:General|Role Teacher title@@general-role-teacher-title:Teacher`;
      break;
    case Role.Student:
      value = $localize`:General|Role Student title@@general-role-student-title:Student`;
      break;
    case Role.Participant:
      value = $localize`:General|Role Participant title@@general-role-participant-title:Participant`;
      break;
  }

  return value;
}
